import React, { useState, useEffect, useRef } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { Link } from '@material-ui/core';
import { PageLoader } from '@app/components';
import { vaultPasswordsService } from '@app/services';

interface IProps {
    onNext: () => void;
    onCancel: () => void;
    setAgent: Function;
}

const PwsDownloadInstaller = (props: IProps) => {
    const [downloadLocation, setDownloadLocation] = useState('');
    const [newAgentFound, setNewAgentFound] = useState(false);
    const [homerealm] = useState(window.location.hostname);
    const [currentStep, setCurrentStep] = useState(1);

    const timerToClear = useRef<any>(null);

    const { translation } = useTypedTranslation();

    const handleNextStep = () => {
        setCurrentStep(2);
        onAgentReturned();
    };

    useEffect(() => {
        vaultPasswordsService.getSyncAgentDownloadLocation()
            .then((response: any) => {
                if (response.data.uri !== '') {
                    setDownloadLocation(response.data.uri);
                }
            });

        // unmount
        return () => {
            if (timerToClear.current !== null) {
                clearInterval(timerToClear.current);
            }
        };
    }, []);

    const onAgentReturned = (response?: any) => {
        if (response?.data?.value[0]) {
            setNewAgentFound(true);
            props.setAgent(response.data.value[0].Id);
            return;
        }
        else {
            timerToClear.current = setTimeout(() => {
                checkAgentApi();
            }, 5000);
        }
    };

    const checkAgentApi = () => {
        vaultPasswordsService.getNewSyncAgent(onAgentReturned);
    };

    return (
        <>
            <div className='rowcontainer'>
                <div className='dirsync__agent'>
                    <img className='dirsync__newImage' src='/assets/images/Dir_sync_image_2.png'></img>
                    {currentStep === 1 &&
                        (

                            <div className='dirsync__agent--content'>
                                <h2>{translation('PWSSYNC_ENDPOINTSETUP_LETS_TITLE')}</h2>
                                <p>{translation('PWSSYNC_ENDPOINTSETUP_LETS_TEXT')}</p>
                                <p>{translation('PWSSYNC_ENDPOINTSETUP_LETS_TEXT2')}</p>

                                <div className='dirsync__agent--links'>
                                    <Link
                                        href={downloadLocation}
                                        download
                                        onClick={handleNextStep}
                                    >
                                        {translation('PWSSYNC_ENDPOINTSETUP_DOWNLOAD')}
                                    </Link>
                                    <Link
                                        component='button'
                                        onClick={handleNextStep}
                                    >
                                        {translation('DIRSYNC_ENDPOINTSETUP_DOWNLOAD_ALREADY')}
                                    </Link>
                                </div>
                            </div>
                        )
                    }

                    {currentStep === 2 &&
                        (
                            <div className='dirsync__agent--content'>
                                <h2>{translation('PWSSYNC_ENDPOINTSETUP_DEPLOYING_TITLE')}</h2>

                                {newAgentFound &&
                                    <>
                                        <div className='dirsync__agent--links'>
                                            <p>{translation('PWSSYNC_ENDPOINTSETUP_DEPLOYING_SUCCESS')}</p>
                                        </div>
                                        <div className='dirsync__bottom--links'>
                                            <Link
                                                component='button'
                                                onClick={props.onNext}
                                            >
                                                {translation('PWSSYNC_NEXT')}
                                            </Link>
                                        </div>
                                    </>
                                }

                                {!newAgentFound &&
                                    (
                                        <>
                                            <p>{translation('PWSSYNC_ENDPOINTSETUP_DEPLOYING_TEXT')}</p>
                                            <div className='dirsync__agent--deploy'>
                                                <p>{translation('PWSSYNC_HOMEREALM_LABEL')}</p>
                                                <p>{homerealm}</p>
                                                <div className='dirsync__agent--loader'>
                                                    <PageLoader />
                                                </div>
                                            </div>
                                            <div className='dirsync__bottom--links'>
                                                <Link
                                                    component='button'
                                                    onClick={props.onCancel}
                                                >
                                                    {translation('CANCEL')}
                                                </Link>
                                            </div>
                                        </>
                                    )
                                }

                            </div>
                        )
                    }
                </div>
            </div>
        </>
    );
};

export default PwsDownloadInstaller;